/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/distributionCenter.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_DISTRIBUTION_CENTERS } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { capitalCase } from "change-case";
import { StorageModule } from "@vlinder-web/storage-module-react";

const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IDistributionCenterMethods extends IPluginMethodMap {
  getDistributionCenter(args: any): Promise<any>;
}

export class DistributionCenterService implements IAgentPlugin {
  readonly methods: IDistributionCenterMethods;

  constructor() {
    this.methods = {
      getDistributionCenter: this.getDistributionCenter.bind(this),
    };
  }

  async getDistributionCenter(args: any) {
    console.log(
      `getDistributionCenter`,
      storageService.get("bandConfig", "local")
    );
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      // return { ...config };
      if (client) {
        const res = await client.query({
          query: GET_DISTRIBUTION_CENTERS,
          variables: {
            options: {
              skip: args?.offset ?? 0,
              limit: args?.size ?? 10,
            },
            filter: {
              ...args?.criteria,
              band__in:
                storageService.get("bandConfig", "local")?.band?.appCardId ??
                null,
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _templateData = this.formatDistCenter(
            res?.data?.getDistCents?.content
          );

          let _totalPages = res?.data?.getDistCents?.count
            ? parseInt(res?.data?.getDistCents?.count) / 10
            : 1;
          let _currentPage =
            res?.data?.getDistCents?.skip / res?.data?.getDistCents?.limit + 1;
          console.log(`row data`, _templateData, _totalPages);
          return {
            ...config,
            appCardList: _templateData,
            isEmpty: res?.data?.getDistCents?.data?.length <= 0,
            activePage: _currentPage,
            pageSize: res?.data?.getDistCents?.limit,
            totalCount: res?.data?.getDistCents?.count,
            totalPages: _totalPages,

            tweetyProps: this.formatFormProps(
              config.TWEETY_PROPS,
              res?.data?.getCompleteDistCents?.content
            ),
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private formatFormProps(formProps: any, completeDistCenters: any) {
    let _tokenCharOptions = this._getTokenCharOptions(completeDistCenters);
    let _res: any = formProps;
    _res.fields = _res.fields.map((field: any) => {
      if (field.compProps.id === "tokenChar") {
        field.compProps.options = _tokenCharOptions;
      }

      return field;
    });
    console.log(`_res in formatFormProps`, _res);
    return _res;
  }

  private formatDistCenter(data: any) {
    let _appCard: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        return {
          id: item?.id,
          appCardId: item?.id,
          appCardImage: item?.logo,
          appCardTitle: item?.name ? item?.name : "",
          //appCardDescription: item?.distCenterId,
          appCardList: [
            {
              name: "Dist Center ID",
              value: item?.distCenterId,
            },
          ],
        };
      });

    return _appCard;
  }

  private _getTokenCharOptions(data: any) {
    let _tokenCharOptions: any = [];
    const _tokenChars = config?.tokenChars;
    if (Array.isArray(data)) {
      _tokenChars.map((tokenChar: any) => {
        let _isExitst: boolean = false;
        data.forEach((item: any) => {
          if (item?.tokenIDChar === tokenChar) {
            _isExitst = true;
          }
        });
        if (!_isExitst) {
          _tokenCharOptions.push({
            label: tokenChar,
            value: tokenChar,
          });
        }
      });
    }
    console.log(`_tokenCharOptions`, _tokenCharOptions);
    return _tokenCharOptions;
  }
}
